import { ApiResponse, Holiday } from '../models';
import * as http from './http';
import ApiService from './service';

export class HolidayService extends ApiService {
  public async loadAllHolidays(): Promise<Holiday[]> {
    const url = `${this.apiDomain}/api/holiday/list`;
    const resposne = await http.get<ApiResponse<Holiday[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updateHoliday(data: Holiday, id?: string) {
    const url = `${this.apiDomain}/api/holiday/${id}`;
    const response = await http.put<ApiResponse<Holiday>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createHoliday(data: Holiday) {
    const url = `${this.apiDomain}/api/holiday`;

    const response = await http.post<ApiResponse<Holiday>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteHoliday(id?: string) {
    const url = `${this.apiDomain}/api/holiday/${id}`;

    const response = await http.remove<ApiResponse<Holiday>>(url, this.store);
    return response.data;
  }

  public async getExcludedDatesForEvents(): Promise<Date[]> {
    const url = `${this.apiDomain}/api/holiday/holidays-list`;
    const resposne = await http.get<ApiResponse<Date[]>>(url, this.store);
    return resposne?.data?.data;
  }
}
